import React from 'react';
import { Text, Flex } from 'theme-ui';
import formatMoney from '~/utils/format-money';

const PriceSection = ({ price, regularPrice, children, forwardSx = {} }) => {
  return (
    <>
      {price !== regularPrice ? (
        <Flex
          sx={(t) => ({
            lineHeight: 0.9,
            letterSpacing: '-0.04em',
            gap: '1.8rem',
            alignItems: 'center',
            fontSize: '3.2rem',
            fontWeight: 'medium',
            '> .strikethrough': {
              fontSize: '2.4rem',
              fontWeight: 'inherit',
              color: 'UIGray1',
              textDecoration: 'line-through',
            },

            ...forwardSx,
          })}
        >
          <Text
            as="span"
            sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}
            aria-label={`Price: ${formatMoney(price)}USD`}
          >
            {formatMoney(price)}
          </Text>
          <Text className="strikethrough" as="span" sx={{ textDecoration: 'line-through' }}>
            {formatMoney(regularPrice)}
          </Text>
        </Flex>
      ) : (
        <Text
          as="p"
          sx={{
            color: (t) => t.colors.black,
            fontSize: '3.2rem',
            fontWeight: 'medium',
            lineHeight: 0.9,
            ...forwardSx,
          }}
          aria-label={`Price: ${formatMoney(price)}USD`}
        >
          {formatMoney(price)}
        </Text>
      )}
      {children}
    </>
  );
};

export default PriceSection;
